var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#003EA8",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6654 25V23.3333H28.332V25H11.6654ZM12.6237 19.9583L11.5404 19.3333L12.2487 18.0833H10.832V16.8333H12.2487L11.5404 15.625L12.6237 15L13.332 16.2083L14.0404 15L15.1237 15.625L14.4154 16.8333H15.832V18.0833H14.4154L15.1237 19.3333L14.0404 19.9583L13.332 18.7083L12.6237 19.9583ZM19.2904 19.9583L18.207 19.3333L18.9154 18.0833H17.4987V16.8333H18.9154L18.207 15.625L19.2904 15L19.9987 16.2083L20.707 15L21.7904 15.625L21.082 16.8333H22.4987V18.0833H21.082L21.7904 19.3333L20.707 19.9583L19.9987 18.7083L19.2904 19.9583ZM25.957 19.9583L24.8737 19.3333L25.582 18.0833H24.1654V16.8333H25.582L24.8737 15.625L25.957 15L26.6654 16.2083L27.3737 15L28.457 15.625L27.7487 16.8333H29.1654V18.0833H27.7487L28.457 19.3333L27.3737 19.9583L26.6654 18.7083L25.957 19.9583Z",
    fill: "#003EA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPayment);
export default __webpack_public_path__ + "static/media/ic-payment.545eae7afd13604d26c7829eb1bab9d0.svg";
export { ForwardRef as ReactComponent };